import Swiper from 'swiper/dist/js/swiper.js';

new Swiper('.swiper-container', {
    autoHeight: false,
    grabCursor: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true'
    },
});